/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { useRef } from "react";
import PropTypes from "prop-types";

function ReceiptBackgroundPanel({
  background,
  onUpload,
  onOpacityChange,
  onRemove,
  loading,
  textObj
}) {
  const fileInputRef = useRef(null);
  const t = (key, fallback) => (textObj && textObj[key]) || fallback;

  const handleUploadClick = () => {
    if (fileInputRef.current) fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      onUpload(file);
      // Reset so the same file can be re-selected
      e.target.value = "";
    }
  };

  const hasBackground = !!(background && background.src);
  const opacity = background && background.opacity != null ? background.opacity : 1;

  return (
    <div className="ReceiptEditor-settingsPanel">
      <div className="ReceiptEditor-settingsRow">
        <div className="ReceiptEditor-settingsLabel">
          {t("backgroundImage", "Background Image")}
        </div>
        <button
          type="button"
          className="ReceiptEditorToolbar-btn"
          onClick={handleUploadClick}
          disabled={loading}
        >
          {hasBackground
            ? t("replaceBackground", "Replace")
            : t("uploadBackground", "Upload")}
        </button>
        <input
          ref={fileInputRef}
          type="file"
          accept="image/png,image/jpeg"
          style={{ display: "none" }}
          onChange={handleFileChange}
        />
      </div>

      {hasBackground && (
        <React.Fragment>
          <div className="ReceiptEditor-settingsRow">
            <div className="ReceiptEditor-settingsLabel">
              {t("backgroundOpacity", "Opacity")}
            </div>
            <div className="ReceiptBackgroundPanel-opacity">
              <input
                type="range"
                min="0"
                max="1"
                step="0.05"
                value={opacity}
                onChange={(e) => onOpacityChange(parseFloat(e.target.value))}
              />
              <span className="ReceiptBackgroundPanel-opacityValue">
                {Math.round(opacity * 100)}%
              </span>
            </div>
          </div>
          <div className="ReceiptEditor-settingsRow">
            <button
              type="button"
              className="ReceiptEditorToolbar-btn ReceiptEditorToolbar-btn--reset"
              onClick={onRemove}
              disabled={loading}
            >
              {t("removeBackground", "Remove Background")}
            </button>
          </div>
        </React.Fragment>
      )}
    </div>
  );
}

ReceiptBackgroundPanel.propTypes = {
  background: PropTypes.object,
  onUpload: PropTypes.func.isRequired,
  onOpacityChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  textObj: PropTypes.object
};

export default ReceiptBackgroundPanel;
